export const LocaleTypeEnum = {
    AreaOperational: 53
};



// WEBPACK FOOTER //
// ./src/enuns/localeTypeNeocom.enum.js